import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { AssessmentCollectionLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const Assessment_collection_Process_Muation = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                {/* <nav className="sidebar card py-2 mb-4">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <Link
                        className="nav-link fontSizeClass"
                        to="/Assessment_Collection_Assessment_Home"
                      >
                        {" "}
                        {t("Assessment Home")}{" "}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link active1 fontSizeClass"
                        to="/Assessment_collection_Process_Muation"
                      >
                        {" "}
                        {t("Process of Mutation")}{" "}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link fontSizeClass"
                        to="/Assessment_Collection_Unit_Area_Assessment"
                      >
                        {" "}
                        {t("Unit Area Assessment")}{" "}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <DownloadFileByFileStoreId
                        fileStoreId={"05fa2075-e0c5-4d32-b035-df381d6820a7"}
                        label={"Tax Rates / Fees"}
                      />
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link fontSizeClass"
                        to="/Assessment_collection_download_forms"
                      >
                        {" "}
                        {t("Download Forms")}{" "}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        className="nav-link fontSizeClass"
                        to="/Assessment_collection_Message_Board"
                      >
                        {" "}
                        {t("Message Board")}{" "}
                      </Link>
                    </li>

                    <li className="nav-item">
                      <a
                        className="nav-link fontSizeClass"
                        href={`${prodURL}/citizen/language-selection`}
                      >
                        {" "}
                        {t("Assessment Online Services")}{" "}
                      </a>
                    </li>
                  </ul>
                </nav> */}
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {AssessmentCollectionLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3 className="fontSizeClass">
                      {t("Process of Mutation")}{" "}
                    </h3>
                  </div>
                  <div className="about-head1">
                    <div className="dig-login1 dig-login2">
                      <form>
                        <div className="log-form inner-log-form">
                          <div className="para_text">
                            <p className="fontSizeClass">
                              At first, please procure the scheduled application
                              form for Mutation called Form{" "}
                              <Link
                                to={"/Assessment_collection_download_forms"}
                              >
                                (A-42)
                              </Link>
                              [see sample]. This can be obtained from Central
                              Record Section in CMO building. It is also
                              available in Gariahat (Tolly Tax) office at Behala
                              (SSU) Office. The form can also be downloaded from
                              the KMC Website.
                            </p>
                            <p className="fontSizeClass">
                              ' No Outstanding Certificate' from Assessment
                              Collection Department is required to be attached
                              with prescribed mutation form <br></br>{" "}
                              <Link
                                to={"/Assessment_collection_download_forms"}
                              >
                                (A-42)
                              </Link>
                              .For obtaining NOC from Assessment Collection
                              Department single dedicated computerised window
                              has been instituted at respective Assessment
                              Collection Units (At CMO Buildings, Tolly Tax,
                              SSU, JU & GRU office) from which either NOC or
                              letter of Intimation (LoI) of demand will be
                              handed over within a specified time limit.
                            </p>
                            <p className="fontSizeClass">
                              Do not forget to attach other papers/documents as
                              mentioned in{" "}
                              <Link
                                to={"/Assessment_collection_download_forms"}
                              >
                                (A-42)
                              </Link>{" "}
                              form.
                            </p>
                            <p className="fontSizeClass">
                              {t(
                                "In case of Mutation on succession ground death certificate of the R/O and an affidavit regarding legal heirs (incase of intestate succession) or probated will (incase of testamentary succession)"
                              )}
                            </p>
                            <p className="fontSizeClass">
                              {t(
                                "In case of mutation and apportionment of tax, please submit a site-plan duly signed by an LBS and the applicant(s) showing the entire area of the premises as well the area(s) under the occupation of the individual applicant(s) along with the prescribed form of mutation"
                              )}
                              <Link
                                to={"/Assessment_collection_download_forms"}
                              >
                                (A-42)
                              </Link>
                              .
                            </p>
                            <p className="fontSizeClass">
                              {t(
                                "In case of Mutation Amalgamation or Mutation-separation please enclose detail site map duly signed by a LBS."
                              )}
                              .
                            </p>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Assessment_collection_Process_Muation;
